import { ensureModuleMessages, registerModuleCatalog } from '@/shared/i18n/i18n';

// Catálogo do módulo (U33). `eager`: os títulos do manifesto aparecem no ⌘K e no breadcrumb antes
// de a tela abrir; em produção a macro tira o texto-fonte e sobraria o id (S31).
registerModuleCatalog('credit-note', (locale) => import(`./locales/${locale}.po`), { eager: true });

export function loadCreditNoteMessages(): Promise<void> {
  return ensureModuleMessages('credit-note');
}
